import { IApplicationState } from '../../types/redux';

export function isFavoritesForAuthorizationEnabled(state: IApplicationState): boolean {
  const { user, results } = state;

  return !user.isAuthenticated && results.favoriteEntities.length > 0;
}
